// extracted by mini-css-extract-plugin
module.exports = {"block":"ButtonBlock_block__3-CrR","title":"ButtonBlock_title__1EOLg","body":"ButtonBlock_body__1NBfK"};